import { useAuth0 } from '@auth0/auth0-react'
import { Navigate, Outlet } from 'react-router-dom'

import { useAdminAccess } from '../../providers/AdminAccessContext'
import Loading from '../Loading/Loading.component'

/**
 * Gates the admin app shell: requires authentication and admin permission
 * (resolved via API so pending invites can be fulfilled before the JWT refreshes).
 */
const AdminShell = (): JSX.Element => {
  const { isAuthenticated, isLoading: isAuth0Loading } = useAuth0()
  const { isAdmin, isLoading: isAdminLoading } = useAdminAccess()

  if (isAuth0Loading || isAdminLoading) {
    return <Loading />
  }

  if (!isAuthenticated) {
    return <Navigate to={`/login/redirect/${encodeURIComponent(window.location.pathname)}`} replace />
  }

  if (!isAdmin) {
    return <Navigate to="/access-denied" replace />
  }

  return <Outlet />
}

export default AdminShell
